<template>
	<article class="faq-page">
		<page-header :title="title" />
		<managing-section>
			<managing-box title="분류">
				<select class="select" ref="staticCode" v-model="staticCode">
					<option
						v-for="item in staticCodeList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
			</managing-box>
			<managing-box title="제목">
				<text-counter
					class="faq__question"
					ref="question"
					v-model="question"
					:max-length="50"
				/>
			</managing-box>
			<managing-box title="노출 상태">
				<RadioList v-model="isDisplay" :radio-list="isDisplayList" />
				<CheckboxList
					v-if="isDisplay === isDisplayList[0].id"
					v-model="isBest"
					:checkboxList="isBestList"
				/>
			</managing-box>
			<managing-box title="내용">
				<text-editor
					class="faq__editor"
					:height="360"
					language="ko_KR"
					v-model="answer"
				/>
			</managing-box>
		</managing-section>
		<div class="btn-wrap-main">
			<button v-if="id" class="btn-main blue" @click="register(true)">
				수정
			</button>
			<template v-else>
				<button class="btn-main" @click="initValues">초기화</button>
				<button class="btn-main blue" @click="register">등록</button>
			</template>
		</div>
	</article>
</template>
<script>
	import { mapGetters } from 'vuex';
	import TextEditor from '@/components/TextEditor';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import TextCounter from '@/components/TextCounter.vue';
	import RadioList from '@/components/RadioList';
	import CheckboxList from '@/components/CheckboxList';

	export default {
		name: 'FAQ',
		components: {
			TextEditor,
			PageHeader,
			ManagingSection,
			ManagingBox,
			TextCounter,
			RadioList,
			CheckboxList,
		},
		data() {
			return {
				title: '자주 묻는 질문 등록',
				id: null,
				staticCode: null,
				maxLength: '',
				question: '',
				isDisplayList: [
					{ id: true, value: '노출' },
					{ id: false, value: '비노출' },
				],
				isDisplay: true,
				isBestList: [{ id: true, value: '상위노출' }],
				isBest: [],
				answer: '',
			};
		},
		computed: {
			...mapGetters(['getListAddNull']),
			staticCodeList() {
				return this.getListAddNull('faqCategory', null, '선택하세요');
			},
		},
		created() {
			this.init();
		},
		methods: {
			async init() {
				const id = Number(this.$route.query.id);
				if (!id) {
					document.title = '자주 묻는 질문 등록';
					this.title = '자주 묻는 질문 등록';
					return;
				}
				document.title = '자주 묻는 질문 수정';
				this.title = '자주 묻는 질문 수정';
				this.id = id;
				const { data } = await this.$axiosAdmin2.get(
					`/v3/api/faq/${id}`
				);
				this.staticCode = data.staticCode;
				this.question = data.question;
				this.$refs.question.textValue = data.question;
				this.isDisplay = data.isDisplay;
				this.isBest = data.isBest ? [true] : [];
				this.answer = data.answer;
			},
			changeFilter(key, value) {
				this[key] = value;
			},
			initValues() {
				if (!confirm('입력된 정보를 전체 초기화 하시겠어요?')) return;
				this.staticCode = this.staticCodeList[0].id;
				this.question = '';
				this.$refs.question.textValue = '';
				this.isDisplay = this.isDisplayList[0].id;
				this.isBest = [];
				this.answer = '';
			},
			async register(isModify) {
				if (this.staticCode === this.staticCodeList[0].id) {
					alert('분류를 선택해 주세요.');
					this.$refs.staticCode.focus();
					return;
				}
				if (!this.question) {
					alert('제목을 입력해 주세요.');
					this.$refs.question.$refs.input.focus();
					return;
				}
				if (!this.answer) {
					alert('내용을 입력해 주세요.');
					return;
				}
				if (isModify && !confirm('수정된 정보로 저장하시겠어요?'))
					return;
				const params = {
					staticCode: this.staticCode,
					question: this.question,
					isDisplay: this.isDisplay,
					isBest: this.isDisplay && !!this.isBest.length,
					answer: this.answer,
				};
				if (isModify) {
					params.id = this.id;
				}
				await this.$axiosAdmin2.post('/v3/api/faq', params);
				this.$router.push('/operation/faq-list');
			},
		},
	};
</script>
<style lang="scss" scoped>
	.faq__question {
		width: 100%;
	}

	.faq__editor {
		width: 100%;
	}
</style>
